import { render, staticRenderFns } from "./CailiaotongzhidanForm.vue?vue&type=template&id=68b6783e&scoped=true&"
import script from "./CailiaotongzhidanForm.vue?vue&type=script&lang=js&"
export * from "./CailiaotongzhidanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b6783e",
  null
  
)

export default component.exports